<template>
  <div class="delivery-tile return-depot-tile mb-3" @click="$emit('click')">
    <div class="delivery-tile-content">
      <div class="delivery-tile-header bg-gray-600">
        <Badge value="⟳" severity="secondary" class="route-position" />
        <h4 class="delivery-title text-white">Retour au dépôt</h4>
      </div>
      
      <div class="delivery-tile-body">
        <div class="address-container">
          <i class="pi pi-map-marker location-icon"></i>
          <span class="address-text">{{ address }}</span>
        </div>
        <div class="navigation-container">
          <Badge icon="pi pi-compass" value="Ouvrir dans Waze" severity="info" class="navigation-badge" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Badge from 'primevue/badge';

// Props
const props = defineProps({
  address: {
    type: String,
    default: '9 rue Nicolas Copernic, 78190 Trappes'
  },
  latitude: {
    type: Number,
    default: 48.765872955322266
  },
  longitude: {
    type: Number,
    default: 1.9921187162399292
  }
});

// Emit events
const emit = defineEmits(['click']);
</script>

<style scoped>
/* Les styles peuvent être importés depuis un fichier CSS commun */
.delivery-tile {
  background-color: #ffffff;
  border-radius: 0.75rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  transition: all 0.2s ease;
  overflow: hidden;
  position: relative;
  border: 1px solid #f3f4f6;
}

.delivery-tile:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
  border-color: #e5e7eb;
}

.return-depot-tile {
  background-color: #F9FAFB;
  border: 1px dashed #D1D5DB;
}

.return-depot-tile:hover {
  border-color: #3B82F6;
  background-color: #F3F4F6;
}

.delivery-tile-content {
  position: relative;
  z-index: 1;
}

.delivery-tile-header {
  padding: 0.875rem 1rem;
  display: flex;
  align-items: center;
  position: relative;
  gap: 0.75rem;
}

.route-position {
  width: 2rem;
  height: 2rem !important;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.25);
  color: #ffffff;
  font-weight: 600;
  flex-shrink: 0;
  border: 2px solid rgba(255, 255, 255, 0.5);
  font-size: 0.9rem;
  padding: 0;
}

.delivery-title {
  color: #ffffff;
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
  line-height: 1.4;
  flex: 1;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}

.delivery-tile-body {
  padding: 1rem;
  background-color: #ffffff;
}

.address-container {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 1rem;
  color: #4B5563;
}

.location-icon {
  color: #3B82F6;
  font-size: 1rem;
  margin-top: 0.2rem;
  flex-shrink: 0;
}

.address-text {
  font-size: 0.95rem;
  line-height: 1.4;
}

.navigation-container {
  display: flex;
  justify-content: center;
  margin-top: 0.75rem;
}

.navigation-badge {
  cursor: pointer;
  background-color: #EFF6FF !important;
  color: #3B82F6 !important;
  border: 1px solid #DBEAFE;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.35rem 0.75rem;
  line-height: 1.2;
}

.navigation-badge:hover {
  background-color: #DBEAFE !important;
  color: #2563EB !important;
}
</style> 